import $ from "jquery";
import { chain, extend, forEach, some } from "lodash";

var NS = ".updateoperationrunner";

var PromiseWrapper = function () {
    this._callbacks = [];
};

extend(PromiseWrapper.prototype, {
    lastDone: function (callback) {
        this._callbacks.push({
            name: "lastDone",
            func: callback
        });
        this._applyCallbacks();
    },

    lastAlways: function (callback) {
        this._callbacks.push({
            name: "lastAlways",
            func: callback
        });
        this._applyCallbacks();
    },

    attachTo: function (operationPromise) {
        this._sourcePromise = operationPromise;
        this._applyCallbacks();
    },

    _applyCallbacks: function () {
        if (this._sourcePromise) {
            var callbacks = this._callbacks;
            this._callbacks = [];

            forEach(callbacks, x => {
                this._sourcePromise[x.name](x.func);
            });
        }
    }
});

const OperationDependencyRule = function (getMasterUID) {
    this.getMasterUIDFunc = getMasterUID;
};

extend(OperationDependencyRule.prototype, {
    getResult: function (uid) {
        var self = this;
        var masterUid = this.getMasterUIDFunc(uid);
        var isMaster = masterUid === uid;

        return {
            isMaster: isMaster,
            masterUid: masterUid,
            isCorrespondToRule: function (depUid) {
                return self.getMasterUIDFunc(depUid) === masterUid;
            }
        };
    }
});

var noMasterRule = new OperationDependencyRule(function () {
    return "no_master";
});

var operationDependencyRules = [];

var getDependencyRule = function (name) {
    var rule = name == null ? null : operationDependencyRules[name];
    return rule || noMasterRule;
};

var UpdateOperationRunner = function () {
    this.init();
};

extend(UpdateOperationRunner.prototype, {
    init: function () {
        this._beforeUnloadInitialized = false;
        this._activeOperations = {};
        this._scheduledOperations = {};
        this._timers = {};
        this._scheduleOperation = this._scheduleOperation.bind(this);
    },

    createPromiseWrapper: function () {
        return new PromiseWrapper();
    },

    run: function (uid, action, timeout) {
        var beforeunloadMsg = null;
        var ruleName = null;
        let notRejectScheduled = false;

        if (arguments.length === 1) {
            var options = arguments[0];
            uid = options.uid;
            action = options.action;
            timeout = options.timeout;
            ruleName = options.ruleName;
            beforeunloadMsg = options.beforeunloadMsg;
            notRejectScheduled = options.notRejectScheduled;
        }

        if (!uid || !action) {
            throw new Error("uid and action are required.");
        }

        if (!this._beforeUnloadInitialized && beforeunloadMsg) {
            $(window).on("beforeunload" + NS, this._onWindowBeforeUnload.bind(this));
            this._beforeUnloadInitialized = true;
        }

        var opWrapper = this._wrapOperation(uid, action, beforeunloadMsg);
        const scheduleOperationFunc = () => this._scheduleOperation(uid, opWrapper, ruleName, notRejectScheduled);

        if (timeout !== undefined) {
            if (opWrapper.beforeunloadMsg) {
                //won't work correctly because until timeout is not ellapsed there is no 
                // item in _activeOperations and data is not saved yet, but _onWindowBeforeUnload won't find this operation and
                // as result won't show confirm message.
                throw new Error("beforeunloadMsg is not supported if timeout was specified");
            }
            this._timeout(uid, scheduleOperationFunc, timeout);
        } else {
            scheduleOperationFunc();
        }

        return opWrapper.promise;
    },

    //only for tests
    dispose: function () {
        if (this._beforeUnloadInitialized) {
            $(window).off(NS);
        }

        chain(this._timers)
            .values()
            .each(function (x) {
                ep.timer.clearTimeout(x);
            }).value();

        this._timers = {};
    },

    _onWindowBeforeUnload: function () {
        var operation = chain(this._activeOperations)
            .values()
            .find(function (x) {
                return !!x.beforeunloadMsg;
            })
            .value();
        if (operation) {
            return operation.beforeunloadMsg;
        }
    },

    _scheduleOperationInQueue: function (uid, opWrapper) {
        this._scheduledOperations[uid] = this._scheduledOperations[uid] || [];
        this._scheduledOperations[uid].push(opWrapper);
    },

    _scheduleOperation: function (uid, opWrapper, ruleName, notRejectScheduled) {
        if (this._isOperationInProc(uid, ruleName)) {
            notRejectScheduled ?
                this._scheduleOperationInQueue(uid, opWrapper) :
                this._rejectAndScheduleOperations(uid, opWrapper, ruleName);
            return;
        }

        this._runOperation(uid, opWrapper, ruleName);
    },

    _runOperation: function (uid, opWrapper, ruleName) {
        var self = this;
        var promise = opWrapper.operation();
        this._activeOperations[uid] = opWrapper;

        promise.always(function () {
            delete self._activeOperations[uid];

            self._runNextScheduledOperations(uid, ruleName);
        });
    },

    _rejectAndScheduleOperations: function (uid, opWrapper, ruleName) {
        var rule = getDependencyRule(ruleName);

        var ruleResult = rule.getResult(uid);

        if (ruleResult.isMaster) {
            forEach(Object.keys(this._scheduledOperations), value => {
                if (ruleResult.isCorrespondToRule(value)) {
                    this._rejectAndScheduleOperation(value);
                }
            });

            this._scheduledOperations[uid] = [opWrapper];
        } else {
            this._rejectAndScheduleOperation(uid, opWrapper);
        }
    },

    _isOperationInProc: function (uid, ruleName) {
        var rule = getDependencyRule(ruleName);

        var ruleResult = rule.getResult(uid);

        if (ruleResult.isMaster) {
            var isSomeDepOperationInProc = some(Object.keys(this._activeOperations), function (value) {
                return ruleResult.isCorrespondToRule(value);
            });

            return isSomeDepOperationInProc;
        }

        return !!this._activeOperations[ruleResult.masterUid] || !!this._activeOperations[uid];
    },

    _runNextScheduledOperations: function (uid, ruleName) {
        var rule = getDependencyRule(ruleName);

        var ruleResult = rule.getResult(uid);


        if (this._hasScheduledOperations(ruleResult.masterUid)) {
            this._runNextScheduledOperation(ruleResult.masterUid, ruleName);
            return;
        }

        if (ruleResult.isMaster) {
            forEach(Object.keys(this._scheduledOperations), value => {
                if (ruleResult.isCorrespondToRule(value)) {
                    this._runNextScheduledOperation(value, ruleName);
                }
            });
        } else {
            this._runNextScheduledOperation(uid, ruleName);
        }
    },

    _runNextScheduledOperation: function (uid, ruleName) {
        if (!this._hasScheduledOperations(uid) || this._isOperationInProc(uid, ruleName)) {
            return;
        }

        let op = this._scheduledOperations[uid].shift();
        this._runOperation(uid, op, ruleName);
    },

    _rejectAndScheduleOperation: function (uid, opWrapper) {
        this._scheduledOperations[uid] = this._scheduledOperations[uid] || [];

        while (this._scheduledOperations[uid].length){
            let op = this._scheduledOperations[uid].shift();
            if (!!op) {
                op.reject();
            }
        }

        if (opWrapper != null) {
            this._scheduledOperations[uid].push(opWrapper);
        }
    },

    _hasScheduledOperations: function (uid) {
        return !!this._scheduledOperations[uid] && this._scheduledOperations[uid].length;
    },

    _wrapOperation: function (uid, operation, beforeunloadMsg) {
        var self = this;
        var result = {};

        var applyCallback = function (callback) {
            return function () {
                var noActiveOperation = !self._activeOperations[uid] || result === self._activeOperations[uid];
                if (noActiveOperation && !self._hasScheduledOperations(uid) && !self._timers[uid]) {
                    callback.apply(this, arguments);
                }
            };
        };

        var promiseExt = {
            _sourcePromise: $.Deferred(),
            lastDone: function (callback) {
                this.done(applyCallback(callback));
                return this;
            },
            lastAlways: function (callback) {
                this.always(applyCallback(callback));
                return this;
            },
            addErrorHandler: function (callback) {
                this._sourcePromise.done(function (source) {
                    if (source.addErrorHandler) {
                        source.addErrorHandler(callback);
                    }
                });

                return this;
            },
            setSourcePromise: function (source) {
                this._sourcePromise.resolve(source);
            }
        };

        var deferred = $.Deferred();
        result = {
            promise: deferred.promise(promiseExt),
            beforeunloadMsg: beforeunloadMsg,
            reject: function () {
                return deferred.reject.apply(this, arguments);
            },
            operation: function () {
                var operationPromis = operation();

                result.promise.setSourcePromise(operationPromis);

                operationPromis.then(function () {
                    return deferred.resolve.apply(this, arguments);
                }, function () {
                    return deferred.reject.apply(this, arguments);
                });

                return operationPromis;
            }
        };

        return result;
    },

    _timeout: function (uid, scheduleFunc, timeout) {
        var timers = this._timers;

        if (timers[uid]) {
            ep.timer.clearTimeout(timers[uid]);
        }

        this._timers[uid] = ep.timer.setTimeout(function () {
            scheduleFunc();
            timers[uid] = null;
        }, timeout);
    }
});

let updateOperationRunner = new UpdateOperationRunner();
const resetUpdateOperationRunner = () => {
    ep.updateOperationRunner = updateOperationRunner = new UpdateOperationRunner();
};

ep.updateOperationRunner = updateOperationRunner;
//just for tests
ep.updateOperationRunnerCtor = UpdateOperationRunner;

export { updateOperationRunner, resetUpdateOperationRunner };
